<template>
    <vue-final-modal name="update-temp-pwd-modal" class="modal-common change"
                     :width="`100%`"
                     :height="`100%`"
                     :transition="`modal-bottom`"
                     :click-to-close="false"
                     :esc-to-close="false"
                     @before-open="handlerBeforeOpen"
                     @opened="handlerOpened"
                     @before-close="handlerBeforeClose"
                     v-model="show"
    >
        <div v-if="show">
            <div class="padding-common">
                <div class="title-modal mb24">비밀번호 변경</div>
                <div class="ta-center">
                    비밀번호 변경을 통해<br>
                    소중한 개인정보를 지켜주세요.<br>
                    안전한 개인정보를 위해 <span>3개월마다 변경</span>해 주세요.
                </div>

                <div class="title-input gray mt24">새 비밀번호</div>

                <el-input placeholder="새 비밀번호" v-model="newPwd" @input="setData('newPwd', newPwd)"
                          class="input-common"
                          :class="{error : validation.hasError('newPwd'), success:!validation.hasError('newPwd') && newPwd !== '' }"
                          :type="newPassType">
                    <template #suffix>
                        <div class="btn-pass" :class="{show : newPassType === 'text'}"
                             @click="changeView('newPassType')"></div>
                    </template>
                </el-input>

                <div class="caption-warn" v-if="validation.hasError('newPwd')">
                    {{ validation.firstError('newPwd') }}
                </div>
                <div class="caption-success" v-if="!validation.hasError('newPwd') && newPwd !== ''">사용가능한
                    비밀번호입니다.
                </div>

                <div class="mt4">
                    <el-input placeholder="새 비밀번호 확인" v-model="newPwdCheck"
                              class="input-common"
                              :class="{error : validation.hasError('newPwdCheck'), success : !validation.hasError('newPwdCheck') && newPwdCheck !== '' }"
                              @input="setData('newPwdCheck', newPwdCheck)"
                              :type="passwordConfirmType">
                        <template #suffix>
                            <div class="btn-pass" :class="{show : passwordConfirmType === 'text'}"
                                 @click="changeView('passwordConfirmType')"></div>
                        </template>
                    </el-input>

                    <div class="caption-warn" v-if="validation.hasError('newPwdCheck')">
                        {{ validation.firstError('newPwdCheck') }}
                    </div>
                    <div class="caption-success"
                         v-if="!validation.hasError('newPwdCheck') && newPwdCheck !== ''">비밀번호가 확인되었습니다.
                    </div>
                </div>
            </div>
            <div class="box-flex inner-half wrap-btn-modal mt20">
                <button class="btn-modal" @click="backEvent()">닫기</button>
                <button class="btn-modal confirm" @click="updatePwd()"
                        :disabled="validation.hasError('newPwd')
                                       || validation.hasError('newPwdCheck') || checkPwdDisabled()">변경하기
                </button>
            </div>
        </div>

    </vue-final-modal>
</template>

<script>
import util from "@/mixins/util";
import SimpleVueValidation from "simple-vue3-validator";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import {logout} from "@/utils/logout";

const Validator = SimpleVueValidation.Validator;

export default {
    name: "UpdateTempPwdModal",
    mixins: [alertMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            newPassType: 'password',
            passwordConfirmType: 'password',
            newPwd: '',
            newPwdCheck: '',
            passwordConfirmed: false,
            show: false,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen() {
            this.validation.reset();
            this.show = true;
            this.newPassType = 'password';
            this.passwordConfirmType = 'password';
            this.newPwd = '';
            this.newPwdCheck = '';
            this.passwordConfirmed = false;
        },
        handlerBeforeClose() {
            this.show = false;
        },
        handlerOpened() {

        },
        backEvent() {
            this.$vfm.hide('update-temp-pwd-modal')
        },
        logoutAfterPasswordChange() {
            this.backEvent();
            logout();
        },
        showPasswordChangedAlert() {
            this.createAlert({
                title: '비밀번호 변경 완료',
                content: '비밀번호 변경으로 모든 플랫폼에서 로그아웃 처리됩니다.<br>다시 로그인해주세요.',
                btnText: '확인',
                hide: () => {
                    this.logoutAfterPasswordChange();
                }
            })
        },
        checkPwdDisabled() {
            if (util.isEmpty(this.newPwd) || util.isEmpty(this.newPwdCheck)) {
                return true
            }
        },
        setData(type, value) {
            this[type] = value
        },
        changeView(data) {
            if (this[data] === 'password') {
                this[data] = 'text'
            } else {
                this[data] = 'password'
            }
        },
        async updatePwd() {
            EventBus.$emit('changeLoading', true)
            let validator = await this.$validate(['newPwd', 'newPwdCheck'])
            if (!validator) {
                EventBus.$emit('changeLoading', false)
                return false;
            }
            let params = {
                newPassword: this.newPwd,
                newPasswordConfirm: this.newPwdCheck,
                passwordConfirmed: this.passwordConfirmed,
            }

            this.$api.$member.updateTempMemberPwd(params).then(res => {
                if (res.code !== 1) {
                    EventBus.$emit('changeLoading', false)
                    this.errorAlert(res.message || '비밀번호 변경에 실패하였습니다.');
                    return false;
                } else {
                    EventBus.$emit('changeLoading', false)
                    this.showPasswordChangedAlert();
                }
            }).catch(() => {
                EventBus.$emit('changeLoading', false)
                this.errorAlert('비밀번호 변경에 실패하였습니다.');
            })
        },
    },
    watch: {},
    validators: {
        newPwd: function (value) {
            let msg = '비밀번호는 영문,숫자,특수문자 조합의 8~16자리를 입력해주세요.'
            return Validator.value(value)
                .required('비밀번호를 입력해주세요.')
                .minLength(8, msg)
                .maxLength(16, msg)
                .regex('^.*(?=^.{8,16}$)(?=.*\\d)(?=.*[a-zA-Z])(?=.*[!)(@#$%^&*|+=_-]).*$', msg)
        },
        newPwdCheck: function (value) {
            return Validator.value(value)
                .required('비밀번호 확인을 입력해주세요.')
                .custom(() => {
                    this.passwordConfirmed = (this.newPwd === value);
                    if (this.newPwd !== value) {
                        return '비밀번호가 일치하지 않습니다.'
                    }
                })
        },
    },
};
</script>

<style scoped>

</style>
